/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_2_TitleInputs */

const en_mk_loop_2_title = /** @type {(inputs: Mk_Loop_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting point recorded`)
};

const id_mk_loop_2_title = /** @type {(inputs: Mk_Loop_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titik awal tercatat`)
};

/**
* | output |
* | --- |
* | "Starting point recorded" |
*
* @param {Mk_Loop_2_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_2_title = /** @type {((inputs?: Mk_Loop_2_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_2_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_2_title(inputs)
	return en_mk_loop_2_title(inputs)
});